import { useQuery, gql } from "@apollo/client";
import { useMemo } from "react";
import props from "./index.d";

interface UseGetForeignKeyListParams {
  foreignKeyParams: props["foreignKeyParams"];
}
function useGetForeignKeyList({ foreignKeyParams }: UseGetForeignKeyListParams): { value: string; label: string }[] {
  const query = useMemo(() => {
    return gql`query ${foreignKeyParams.entityName}GetForeignKeyList {
          elems:${foreignKeyParams.entityName}{
            items{
            value:id
            label: ${foreignKeyParams.column}
            }
          }
        }`;
  }, [foreignKeyParams]);
  const { data } = useQuery(query);
  return data?.elems?.items ?? [];
}

export default useGetForeignKeyList;
